import React from "react";
import Text from "../context/language-context";
import { Dayjs } from "dayjs";

function getNumberInLanguage(number: number) {
  // const languageContext = useContext(LanguageContext)
  const numStr = number.toString();
  let converted = "";

  for (const char of numStr) {
    if (/[0-9]/.test(char)) {
      converted += Text({
        tid: char.toString(),
        def: "",
      });
    } else {
      converted += char; // non-digit character remains unchanged
    }
  }
  return converted;
}

const stringDateInLanguage = (date: string) => {
  if (!date) return null;

  const parts = date.includes("-") ? date.split("-") : [];

  const finalString = parts
    .map((part) => getNumberInLanguage(Number(part)))
    .join("-");

  return finalString;
};

const disableFutureYears = (current: Dayjs | null): boolean => {
  return !!current && current.year() > new Date().getFullYear();
};

const disableFutureMonths = (current: Dayjs | null): boolean => {
  const today = new Date();
  return (
    !!current &&
    (current.year() > today.getFullYear() ||
      (current.year() === today.getFullYear() &&
        current.month() > today.getMonth()))
  );
};

const disableFutureDates = (current: Dayjs | null): boolean => {
  return !!current && current.isAfter(new Date(), "day");
};

export {
  getNumberInLanguage,
  disableFutureYears,
  disableFutureMonths,
  disableFutureDates,
  stringDateInLanguage,
};
